module.exports = __webpack_public_path__ + "app/registrations-request/registration-request-list-1NdwY6J1.html";